import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { CanvasControllerService } from '../../../../../../services/canvas-controller/canvas-controller.service';
import { ProjectControllerService } from '../../services/project-controller/project-controller.service';
import {
  CapturePreviewDialogComponent,
  CapturePreviewData,
} from '../capture-preview-dialog/capture-preview-dialog.component';

@Component({
  selector: 'screen-control-bar',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule, MatDialogModule],
  templateUrl: './screen-control-bar.component.html',
  styleUrl: './screen-control-bar.component.scss',
  providers: [DatePipe],
})
export class ScreenControlBarComponent implements OnInit {
  @Input() canvasController!: CanvasControllerService;
  @Input() projectController!: ProjectControllerService;

  // HTML에서 사용하는 속성들
  @Input() col: boolean = false;
  @Input() isAutoRotate: boolean = false;
  @Input() isScreenShot: boolean = false;
  @Input() isTheme: boolean = false;
  @Input() isFullScreen: boolean = false;
  @Input() isFirstCameraPosition: boolean = false;

  // 컴포넌트 상태
  public isAutoRotation: boolean = true;
  public isFull: boolean = false;
  public theme: 'light' | 'dark' = 'light';

  constructor(
    private date: DatePipe,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {}

  captureAllAngles(): void {
    this.canvasController.captureAllAngles().then((result: any) => {
      console.log(result);

      // 다이얼로그로 캡처 결과 보여주기
      const dialogData: CapturePreviewData = {
        front: result.front,
        back: result.back,
        top: result.top,
        left: result.left,
      };

      this.dialog.open(CapturePreviewDialogComponent, {
        data: dialogData,
        width: '50%',
        maxWidth: '1200px',
        height: 'auto',
        disableClose: false,
        panelClass: 'capture-preview-dialog-panel',
      });
    });
  }

  // 기존 메서드들 추가
  public onClickAutoRotation(): void {
    this.isAutoRotation = !this.isAutoRotation;
    this.canvasController.canvas?.autoRatation(this.isAutoRotation);
  }

  public onClickTheme(): void {
    this.theme = this.theme === 'light' ? 'dark' : 'light';
    if (this.theme === 'dark') {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }

  public goFullScreen(): void {
    const elem = document.documentElement as any;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
    this.isFull = true;
  }

  public exitFullscreen(): void {
    const doc = document as any;
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (doc.webkitExitFullscreen) {
      doc.webkitExitFullscreen();
    } else if (doc.mozCancelFullScreen) {
      doc.mozCancelFullScreen();
    } else if (doc.msExitFullscreen) {
      doc.msExitFullscreen();
    }
    this.isFull = false;
  }

  public firstCameraSet(): void {
    this.canvasController.firstCameraSet();
  }
}
